import React, { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { FieldProps } from 'formik';
import {
  Divider,
  FormControlLabel,
  List,
  ListItem,
  Radio,
  RadioGroup,
  Typography,
  Box,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Portfolio } from 'modules/common/PortfolioManager/types';

type PortfoliosSelectControlProps = FieldProps & {
  portfolios: Portfolio[];
  search: string;
};

const useStyles = makeStyles({
  listItem: {
    margin: 'unset',
    paddingLeft: 'unset',
    paddingRight: 'unset',
  },
});

export const PortfoliosSelectControl: FC<PortfoliosSelectControlProps> = ({
  field,
  portfolios,
  search,
  ...props
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const filtered = portfolios.filter((item) =>
    search ? item.name.toLowerCase().includes(search.toLowerCase()) : item,
  );

  if (filtered.length === 0) {
    return (
      <Box marginTop={2}>
        <Typography>{t('NO_ITEMS_FOUND')}</Typography>
      </Box>
    );
  }

  return (
    <List component={RadioGroup} {...field} {...props}>
      {filtered.map((item) => (
        <Fragment key={item.id}>
          <ListItem
            button
            component={FormControlLabel}
            value={item.id}
            control={<Radio />}
            label={item.name}
            className={classes.listItem}
          />
          <Divider />
        </Fragment>
      ))}
    </List>
  );
};
